
export const getAssignmentsForTask = (assignments: any[], taskId: string) => {
  const taskAssignments = assignments.filter(assignment => assignment.task_id === taskId);
  
  // Sort by role hierarchy and then alphabetically by name
  const roleOrder = { 'director': 1, 'manager': 2, 'team-lead': 3, 'team-member': 4 };
  
  return taskAssignments.sort((a, b) => {
    const roleA = a.role?.toLowerCase() || '';
    const roleB = b.role?.toLowerCase() || '';
    
    // First sort by role hierarchy
    const orderA = roleOrder[roleA as keyof typeof roleOrder] || 5;
    const orderB = roleOrder[roleB as keyof typeof roleOrder] || 5;
    
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    
    // Then sort alphabetically by name
    const nameA = a.name || '';
    const nameB = b.name || '';
    return nameA.localeCompare(nameB);
  });
};

export const getTaskDatesFromAssignments = (
  taskId: string, 
  assignments: any[], 
  projectTasks: any[]
) => {
  // Get dates from existing assignments for this task
  const taskAssignments = assignments.filter(assignment => assignment.task_id === taskId);
  if (taskAssignments.length > 0) {
    // Use the first assignment's dates as they should be consistent for the task
    return {
      start_date: taskAssignments[0].start_date || '',
      end_date: taskAssignments[0].end_date || ''
    };
  }
  
  // Fallback to project tasks if no assignments exist yet
  const task = projectTasks.find(t => t.task_id === taskId);
  return {
    start_date: task?.start_date || '',
    end_date: task?.end_date || ''
  };
};
